import { render, staticRenderFns } from "./ViewOrderCreationAccessories.vue?vue&type=template&id=5d4be0bf&"
import script from "./ViewOrderCreationAccessories.vue?vue&type=script&lang=ts&"
export * from "./ViewOrderCreationAccessories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports